import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";

// Alt Bileşenler
import FinansIstatistikleri from "./walletStats";
import FinansGrafik from "./walletOverView";
import SonIslemler from "./walletActivities";

const SistemFinans = () => {
  document.title = "Sistem Finans Özeti | LojGo Admin";

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3;

  const [isLoading, setIsLoading] = useState(true);
  const [stats, setStats] = useState({
    totalRevenue: 0,
    pendingPayments: 0,
    completedTrips: 0,
    walletHistory: []
  });

  useEffect(() => {
    const fetchSystemStats = async () => {
      setIsLoading(true);
      try {
        if (!isAdmin) {
          toast.error("Bu sayfayı görüntüleme yetkiniz yok.");
          return;
        }

        // 1. Tüm İlanları (Gezileri) Çek (Sistem Cirosu ve Bekleyenler için)
        const advResponse = await fetch("https://hiflowapi.stechomeyazilim.info/Advert?$orderby=Created_DateTime desc");
        const advResult = await advResponse.json();

        let totalRev = 0;
        let pending = 0;
        let completed = 0;
        let history = [];

        if (advResult && advResult.value) {
          advResult.value.forEach(item => {
            if (item.Price) totalRev += parseFloat(item.Price);
            if (item.Advert_Status === "Bekliyor") pending += parseFloat(item.Price || 0);
            if (item.Advert_Status === "Tamamlandı") completed += 1;
            
            // Tablo için geçmiş oluştur
            history.push({
              idno: `TRP-${item.ID}`,
              date: item.Created_DateTime,
              type: item.Advert_Status === "Tamamlandı" ? "Gelir" : "Gider",
              user: item.Customer_Notes || "Bilinmiyor",
              amount: item.Price || 0,
              status: item.Advert_Status || "İşlemde"
            });
          });
        }

        setStats({
          totalRevenue: totalRev,
          pendingPayments: pending,
          completedTrips: completed,
          walletHistory: history
        });

      } catch (error) {
        toast.error("Veriler yüklenirken hata oluştu.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSystemStats();
  }, [isAdmin]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Finans" breadcrumbItem="Sistem Özeti" />
          
          {isLoading ? <div className="text-center py-5"><Spinner color="primary"/></div> : (
            <>
              <Row>
                <Col xl="4">
                  <FinansIstatistikleri stats={stats} user={authUser} />
                </Col>
                
                <Col xl="8">
                  <Row>
                    <Col sm="4">
                      <Card className="mini-stats-wid shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex">
                            <div className="me-3 align-self-center">
                              <i className="mdi mdi-cash-multiple h2 text-success mb-0" />
                            </div>
                            <div className="flex-grow-1">
                              <p className="text-muted mb-2">Toplam Sistem Cirosu</p>
                              <h5 className="mb-0">{stats.totalRevenue.toLocaleString('tr-TR')} €</h5>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="4">
                      <Card className="mini-stats-wid shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex">
                            <div className="me-3 align-self-center">
                              <i className="mdi mdi-clock-outline h2 text-warning mb-0" />
                            </div>
                            <div className="flex-grow-1">
                              <p className="text-muted mb-2">Bekleyen Ödemeler</p>
                              <h5 className="mb-0">{stats.pendingPayments.toLocaleString('tr-TR')} €</h5>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="4">
                      <Card className="mini-stats-wid shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex">
                            <div className="me-3 align-self-center">
                              <i className="mdi mdi-truck-check-outline h2 text-primary mb-0" />
                            </div>
                            <div className="flex-grow-1">
                              <p className="text-muted mb-2">Tamamlanan Sefer</p>
                              <h5 className="mb-0">{stats.completedTrips} Adet</h5>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  <FinansGrafik />
                </Col>
              </Row>

              <Row>
                <Col lg="12">
                  <SonIslemler history={stats.walletHistory} />
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default SistemFinans;